export default "__VITE_ASSET__BQYcXdNG__"